/*
 * 小样选择弹窗（snippets/swatch-sheet.liquid 的 [data-swatch-sheet]），PDP 和小样集合页共用。
 * 2026-10-15 改版：颜色网格多选 + 一次加入，替代原来「一张卡一个颜色、逐个 ADD SWATCH」的轮播。
 *
 * 两种页面的差别只有三处（data-swatch-sheet-mode="collection" 是小样页）：
 *   - 格子：PDP 由 Liquid 渲染好；小样页每次打开前由 products-grid-swatch.js 按点的那张卡生成，所以格子每次打开重新读；
 *   - 加入成功后：PDP 关弹窗并打开购物车抽屉；小样页关弹窗留在原地（右侧 / 底部的已选清单就是反馈，连选几块面料不被抽屉打断）；
 *   - 预览区：小样页多一排 Shop this color（tile 的 data-shop-links）。
 * 加入 / 移除之后都会在 document 上派发 swatch-sheet:change，页面自己同步网格和清单。
 *
 * 开关和焦点仍走主题既有的那一套：显隐靠容器 display（打开 flex / 关闭 none），
 * global.js 的 openThemeProductSwatchDialog(container, opener) 负责焦点圈定、Escape、滚动锁，
 * 它关闭时调 container.click() —— 所以容器上的 click（非指针触发）要能关。
 *
 * 规则沿用原来的：
 *   - 上限 10 片按 isSwatchLineItem（utils.js，按 handle 认，付费色卡本不算）数整车小样；
 *   - 售罄格子由 Liquid 标 data-sold-out（小样自己售罄，或当前成品同色全部售罄）；
 *   - 加入走 addMultipleToCart（utils.js：422 当失败、等 cartData 刷新），失败给 swatchAddError；
 *   - 成功后关弹窗、刷新抽屉、打开抽屉；移除走 cart-drawer-items.removeVariant。
 * 和原版不同：浏览/加入小样不再顺手改 PDP 上选中的颜色（原来翻页会点 PDP 的颜色 label）。
 */
(function () {
  'use strict';
  var sheet = document.querySelector('[data-swatch-sheet]');
  if (!sheet || sheet.__swatchSheet) return;
  sheet.__swatchSheet = true;

  var LIMIT = 10;
  var pageMode = sheet.getAttribute('data-swatch-sheet-mode') === 'collection';
  var tiles = [];
  function readTiles() { tiles = [].slice.call(sheet.querySelectorAll('[data-swatch-tile]')); }
  readTiles();
  var q = function (sel) { return sheet.querySelector(sel); };
  var preview = q('[data-swatch-preview]'), nameEl = q('[data-swatch-name]'), stateEl = q('[data-swatch-state]');
  var views = q('[data-swatch-views]'), removeBtn = q('[data-swatch-remove]'), countEl = q('[data-swatch-count]');
  var pickedEl = q('[data-swatch-picked]'), noteEl = q('[data-swatch-note]'), addBtn = q('[data-swatch-add]');
  var headingEl = q('[data-swatch-heading]'), shopEl = q('[data-swatch-shop]'), shopLinksEl = q('[data-swatch-shop-links]');
  var limitText = sheet.getAttribute('data-limit-text') || 'You have reached the limit of 10 free swatches.';
  // Liquid 使用当前店铺语言输出词典；旧缓存或离线 fixture 没有词典时仍可用。
  var copy = {};
  try { copy = JSON.parse(q('[data-swatch-copy]')?.textContent || '{}') || {}; } catch (_) { /* Keep English fallback. */ }
  var fallbackCopy = {
    fabric: 'fabric swatch', curtain: 'curtain', sold_out: 'Sold out', in_bag: 'In your bag', selected: 'Selected',
    limit_reached: 'Limit reached', selected_count: '{{ count }} selected', adding: 'Adding…',
    add_one: 'Add {{ count }} swatch', add_many: 'Add {{ count }} swatches', select_swatches: 'Select swatches',
    cap_selected: 'That makes {{ count }} free swatches. Deselect one to choose a different colour.',
    remove_failed: 'We could not remove this swatch. Please try again.', add_failed: 'Something went wrong. Please try again.',
    label_sold_out: ', sold out', label_in_bag: ', in your bag', label_selected: ', selected',
    heading: 'Free __fabric__ swatches'
  };
  function text(key, count) {
    var value = typeof copy[key] === 'string' && copy[key] ? copy[key] : fallbackCopy[key];
    return count === undefined ? value : value.replace(/\{\{\s*count\s*\}\}|__count__/g, String(count));
  }

  var selected = [];          // 按点选顺序，加入时也按这个顺序
  var focusId = null;         // 预览区正在看的颜色
  var view = 'fabric';
  var busy = false;
  var note = '';
  var shopFor = null;         // 预览区 Shop this color 当前画的是哪个颜色（换了才重画）

  function idOf(tile) { return tile.getAttribute('data-id'); }
  function tileById(id) { return tiles.filter(function (t) { return idOf(t) === String(id); })[0] || null; }
  function isOpen() { return getComputedStyle(sheet).display !== 'none'; }
  // 与 snippets/swatch-color-key.liquid 相同：同色的空格、标点及 gray/grey 差异不能改变预选。
  function colorKey(value) { return String(value || '').toLowerCase().replace(/[ \-_/.,&'()+]/g, '').replace(/gray/g, 'grey'); }
  function reconcileSelection(b) {
    selected = selected.filter(function (id) { return !b.ids[id]; });
  }

  // 整车小样：各变体件数 + 总数（总数含别的面料的小样，上限是整车 10 片）
  function bag() {
    var ids = {}, total = 0;
    var items = (typeof cartData !== 'undefined' && cartData && cartData.items) || [];
    items.forEach(function (item) {
      if (typeof isSwatchLineItem === 'function' && !isSwatchLineItem(item)) return;
      total += item.quantity;
      ids[String(item.variant_id)] = (ids[String(item.variant_id)] || 0) + item.quantity;
    });
    return { ids: ids, total: total };
  }

  function render() {
    var b = bag();
    // helper 逐项提交后才同步购物车；部分成功的颜色已在袋中，不能继续占待加名额或重试加第二片。
    reconcileSelection(b);
    var room = LIMIT - b.total - selected.length;
    if (countEl) countEl.textContent = String(b.total);

    var anyCapped = false;
    tiles.forEach(function (tile) {
      var id = idOf(tile);
      var inBag = !!b.ids[id];
      var sold = tile.hasAttribute('data-sold-out');
      var isSel = selected.indexOf(id) >= 0;
      var capped = !isSel && !inBag && !sold && room <= 0;
      if (capped) anyCapped = true;
      tile.classList.toggle('is-selected', isSel);
      tile.classList.toggle('is-in-bag', inBag);
      tile.classList.toggle('is-capped', capped);
      tile.classList.toggle('is-focused', id === focusId);
      tile.setAttribute('aria-pressed', isSel ? 'true' : 'false');
      // 不可选（售罄 / 数满）用 aria-disabled 而不是 disabled：保留可聚焦，读屏能听到原因
      tile.setAttribute('aria-disabled', sold || capped ? 'true' : 'false');
      var label = tile.querySelector('[data-swatch-tile-label]');
      if (label) {
        label.textContent = tile.getAttribute('data-name') + (sold ? text('label_sold_out') : inBag ? text('label_in_bag') : isSel ? text('label_selected') : '');
      }
    });

    // 预览区
    var tile = tileById(focusId);
    if (tile) {
      var curtain = tile.getAttribute('data-curtain');
      if (!curtain && view === 'curtain') view = 'fabric';
      var src = view === 'curtain' ? curtain : tile.getAttribute('data-fabric');
      // 换图前先摘掉 src：直接改 src 时浏览器会一直画着上一张，直到新图下完 —— 重开弹窗 / 换颜色时名字已经变了、图还是别的颜色
      //（2026-10-16 小样页实测：Ivory White 下面挂着 Haze Blue 的成品图）。摘掉后先露灰底占位，下完再显示。
      if (!src || preview.getAttribute('src') !== src) {
        preview.removeAttribute('src');
        if (src) preview.src = src;
      }
      // 集合页跨面料共用预览：无图时清空旧图并露出外层占位，不能沿用上一块面料的图。
      preview.hidden = !src;
      preview.alt = tile.getAttribute('data-name') + ' ' + text(view === 'curtain' ? 'curtain' : 'fabric');
      nameEl.textContent = tile.getAttribute('data-name');
      views.hidden = !curtain;
      [].forEach.call(views.querySelectorAll('[data-swatch-view]'), function (btn) {
        btn.setAttribute('aria-pressed', btn.getAttribute('data-swatch-view') === view ? 'true' : 'false');
      });
      var id = idOf(tile), inBag = !!b.ids[id];
      stateEl.textContent = tile.hasAttribute('data-sold-out') ? text('sold_out')
        : inBag ? text('in_bag')
        : selected.indexOf(id) >= 0 ? text('selected')
        : room <= 0 ? text('limit_reached') : '';
      stateEl.className = 'swatch-sheet__state' + (inBag || selected.indexOf(id) >= 0 ? ' is-positive' : '');
      removeBtn.hidden = !inBag;
      renderShop(tile);
    }

    pickedEl.textContent = selected.length ? text('selected_count', selected.length) : '';
    var n = selected.length;
    addBtn.disabled = busy || n === 0;
    addBtn.textContent = busy ? text('adding') : n ? text(n === 1 ? 'add_one' : 'add_many', n) : text('select_swatches');
    // 袋里已满 10 片：用主题设置里的上限文案（可后台改）；是本次选的把名额占满：只需取消一个，不是"从清单里删一个"
    var capNote = b.total >= LIMIT ? limitText : text('cap_selected', LIMIT);
    noteEl.textContent = note || (anyCapped ? capNote : '');
    noteEl.classList.toggle('is-error', !!note);
  }

  function setNote(text) { note = text || ''; }

  // 小样页：这个颜色能买到的成品。链接由 products-grid-swatch.js 从卡片头部的 Available as 抄来（已带 ?selectcolor=）。
  // 用 DOM API 拼，不拼 HTML 字符串：款式名 / 标题来自商品数据。
  function renderShop(tile) {
    if (!shopEl || !shopLinksEl) return;
    var id = tile ? idOf(tile) : null;
    if (id === shopFor) return;
    shopFor = id;
    var links = [];
    try { links = JSON.parse((tile && tile.getAttribute('data-shop-links')) || '[]') || []; } catch (_) { links = []; }
    shopLinksEl.textContent = '';
    links.forEach(function (link) {
      if (!link || !link.href) return;
      var a = document.createElement('a');
      a.className = 'swatch-sheet__shop-link';
      a.href = link.href;
      a.textContent = link.label || '';
      if (link.title) a.title = link.title;
      if (link.track) a.setAttribute('click-data', link.track);
      shopLinksEl.appendChild(a);
    });
    shopEl.hidden = !shopLinksEl.children.length;
  }

  // 背景锁滚动（global.js 给 body 加 theme-guide-scroll-locked = overflow:hidden）会收掉常显滚动条，整页右移一个滚动条宽。
  // 打开前后各量一次 html 盒宽，变宽了就在 html 上补等量 padding-right；手机 / macOS 浮层滚动条宽度是 0，什么都不做。
  // ⚠ 比 html 盒宽，不用 innerWidth - clientWidth：Chromium 保住滚动条槽位时 clientWidth 照报满宽，按它补反而多垫（BASE-035 实测）。
  var paddedRoot = false;
  function reserveScrollbar(widthBefore) {
    var grown = document.documentElement.getBoundingClientRect().width - widthBefore;
    if (grown > 0.5) {
      document.documentElement.style.paddingRight = grown + 'px';
      paddedRoot = true;
    }
  }
  function releaseScrollbar() {
    if (!paddedRoot) return;
    document.documentElement.style.paddingRight = '';
    paddedRoot = false;
  }

  function announceChange() {
    document.dispatchEvent(new CustomEvent('swatch-sheet:change', { detail: { mode: pageMode ? 'collection' : 'product' } }));
  }

  function choose(tile) {
    if (busy || !tile) return;
    var id = idOf(tile);
    focusId = id;
    setNote('');
    var b = bag();
    reconcileSelection(b);
    var at = selected.indexOf(id);
    if (tile.hasAttribute('data-sold-out') || b.ids[id]) { render(); return; }
    if (at >= 0) selected.splice(at, 1);
    else if (LIMIT - b.total - selected.length > 0) selected.push(id);
    render();
  }

  // options（小样页用）：id = 点的那个颜色的变体 id（比按颜色名找更准）；fabric = 顶栏标题里的面料名
  function open(color, opener, options) {
    options = options || {};
    readTiles();
    selected = [];
    setNote('');
    view = 'fabric';
    shopFor = null;
    if (headingEl && options.fabric) headingEl.textContent = text('heading').replace('__fabric__', options.fabric);
    var wanted = colorKey(color);
    var matched = (options.id && tileById(options.id)) ||
      (wanted && tiles.filter(function (t) { return colorKey(t.getAttribute('data-color')) === wanted; })[0]);
    var tile = matched ||
      tiles.filter(function (t) { return !t.hasAttribute('data-sold-out'); })[0] || tiles[0];
    focusId = tile ? idOf(tile) : null;
    // 只预选已匹配的 PDP 颜色；未知色可以预览首格，但不能替用户选择另一个颜色。
    var b = bag();
    if (matched && !tile.hasAttribute('data-sold-out') && !b.ids[focusId] && b.total < LIMIT) selected.push(focusId);
    // html 宽度要在锁滚动**之前**量（锁在下面 openThemeProductSwatchDialog 里加）
    var rootWidth = document.documentElement.getBoundingClientRect().width;
    sheet.style.display = 'flex';
    render();
    var body = q('.swatch-sheet__body');
    if (body) body.scrollTop = 0;
    if (tile && tile.scrollIntoView) tile.scrollIntoView({ block: 'nearest' });
    if (typeof openThemeProductSwatchDialog === 'function') openThemeProductSwatchDialog(sheet, opener);
    reserveScrollbar(rootWidth);
  }

  function close() {
    if (busy) return;
    sheet.style.display = 'none';
    // 锁由 global.js 的观察器在 display 变化后摘掉（同一个微任务检查点，中间不绘制），这里先撤补位
    releaseScrollbar();
  }

  // ---------- 事件 ----------
  // 共享指南的 Tab 圈定使用 preventScroll；网格现在有独立纵向滚动区，只补偿内部被裁掉的焦点。
  // 直接调整 body.scrollTop，避免 scrollIntoView 连带移动 PDP 或固定的页头/页脚。
  sheet.addEventListener('focusin', function (event) {
    var body = q('.swatch-sheet__body');
    if (!isOpen() || !body || !body.contains(event.target)) return;
    var bounds = body.getBoundingClientRect();
    var top = bounds.top + body.clientTop;
    var bottom = top + body.clientHeight;
    var rect = event.target.getBoundingClientRect();
    var pad = 2; // 留出 focus-visible 外描边。
    if (rect.top - pad < top) body.scrollTop += rect.top - pad - top;
    else if (rect.bottom + pad > bottom) body.scrollTop += rect.bottom + pad - bottom;
  });
  // 遮罩：按下和松开都在遮罩上才关（从格子里拖到外面不误关）；
  // 没有指针的 click（global.js 处理 Escape 时调 container.click()）直接关。
  var pressedOnBackdrop = false;
  sheet.addEventListener('pointerdown', function (event) { pressedOnBackdrop = event.target === sheet; });
  sheet.addEventListener('click', function (event) {
    if (event.target !== sheet) return;
    var fromPointer = event.detail > 0;
    if (!fromPointer || pressedOnBackdrop) close();
    pressedOnBackdrop = false;
  });
  q('.exit').addEventListener('click', close);

  // 委托在弹窗上：小样页每次打开都会换一批格子
  sheet.addEventListener('click', function (event) {
    var tile = event.target.closest && event.target.closest('[data-swatch-tile]');
    if (tile && sheet.contains(tile)) choose(tile);
  });

  [].forEach.call(sheet.querySelectorAll('[data-swatch-view]'), function (btn) {
    btn.addEventListener('click', function () { view = btn.getAttribute('data-swatch-view'); render(); });
  });

  removeBtn.addEventListener('click', async function () {
    if (busy || !focusId) return;
    var items = document.querySelector('cart-drawer-items');
    if (!items || typeof items.removeVariant !== 'function') return;
    // 键盘按的：移除成功后这个按钮会藏起来，焦点不能跟着丢到页面上，交给这个颜色的格子（Tab 从这里接着走）
    var hadFocus = document.activeElement === removeBtn;
    busy = true; setNote(''); render();
    try {
      var ok = await items.removeVariant(focusId);
      if (ok === false) setNote(text('remove_failed'));
    } catch (error) {
      console.error('[swatch-sheet] remove failed', error);
      setNote(text('remove_failed'));
    } finally {
      busy = false;
      if (typeof Product_swatchCartChange === 'function') Product_swatchCartChange();
      announceChange();
      render();
      var removedTile = tileById(focusId);
      if (hadFocus && removeBtn.hidden && removedTile && isOpen()) removedTile.focus({ preventScroll: true });
    }
  });

  addBtn.addEventListener('click', async function () {
    if (busy) return;
    if (typeof addMultipleToCart !== 'function') return;
    // 加入前按已同步的购物车复核；真正提交时 CartFlow 还会读取服务端购物车检查上限。
    var b = bag();
    reconcileSelection(b);
    if (!selected.length) { render(); return; }
    if (b.total + selected.length > LIMIT) {
      if (typeof swatchLimitNotice === 'function') swatchLimitNotice();
      setNote(limitText); render(); return;
    }
    busy = true; setNote(''); render();
    var items = selected.map(function (id) { return { id: Number(id), quantity: 1 }; });
    try {
      var results = await addMultipleToCart(items);
      // ⚠ addMultipleToCart 失败也会正常 resolve（错误放在 results 里）
      var failed = (results || []).filter(function (r) { return r.status !== 'success'; })[0];
      if (failed) {
        var why = (failed.data && (failed.data.description || failed.data.message)) || '';
        if (typeof swatchAddError === 'function') swatchAddError(why);
        setNote(why || text('add_failed'));
        return;
      }
      selected = [];
      busy = false;
      close();
      // onCartDrawerUpdate 返回 false = 抽屉没更新上；带着旧内容开抽屉等于"加了但没看到"，整页刷新
      var drawerItems = document.querySelector('cart-drawer-items');
      if (drawerItems && (await drawerItems.onCartDrawerUpdate()) === false) { window.location.reload(); return; }
      if (typeof Product_swatchCartChange === 'function') Product_swatchCartChange();
      announceChange();
      // 小样页：留在原地，已选清单（桌面右侧 / 手机底部条）就是反馈；PDP：打开购物车抽屉
      var drawer = document.querySelector('cart-drawer');
      if (!pageMode && drawer && typeof drawer.open === 'function') drawer.open();
    } catch (error) {
      console.error('[swatch-sheet] add failed', error);
      setNote(text('add_failed'));
    } finally {
      busy = false;
      render();
    }
  });

  // 抽屉里删了小样 / 别处改了购物车：开着的时候跟着刷新计数和打勾
  document.addEventListener('cart:rendered', function () { if (isOpen()) render(); });

  window.openSwatchSheet = open;
  render();
})();
